import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { BaseService } from '../../services/base.service';
import { PrintOptions } from '../../constants/PrintOptions';
import { PrintService } from '../../services/print.service';
import { Router, ActivatedRoute } from '@angular/router';
import { SegmentEvents }from '../../constants/SegmentEvents';
import { SegmentService } from '../../services/segment.service';
import { MapService } from '../../services/map.service';
import { MyStuffService } from '../../services/my-stuff.service';
import { NotificationService } from '../../services/notification.service';
import PerfectScrollbar from 'perfect-scrollbar';

@Component({
  selector: 'app-print',
  templateUrl: './print.component.html',
  styleUrls: ['./print.component.less'],
  encapsulation: ViewEncapsulation.None
})
export class PrintComponent implements OnInit {

  printOptions: any = PrintOptions;
	isPrintDropdownOpen: boolean = false;
  selectedPrintOption: any;
  showPrintPreviewStep2: boolean = false;
  perfectScrollbar: any;

  constructor(public baseService: BaseService, public printService: PrintService,
              public activatedRoute: ActivatedRoute, public segmentService: SegmentService,
              public mapService: MapService, public myStuffService: MyStuffService, public notificationService: NotificationService) { }

  ngOnInit() {
    this.addPrintPreviewStep1Setting();
  }

  togglePrintDropdown(toggle) {
  	this.isPrintDropdownOpen = toggle;
    (<any>window).Events.publish('detectChanges');
  }

  selectPrintMode(printOption) {
    this.selectedPrintOption = this.printOptions.find(function(obj){
      return obj.name === printOption;
    });
    (<any>window).printMode.start({'printName':this.selectedPrintOption.size});
    this.togglePrintDropdown(false);
  }

  cancelPrintMode() {
    this.printService.closePrintPreviewSource.next(true);
    this.removePrintPreviewStep1Setting();
    this.removePrintModeMapSetting();
  }

  startPrintMode() {
    let w = (<any>window);
    setTimeout(()=>{
      if(this.selectedPrintOption.size === 'tabloid') {
        let map = document.getElementById('marqet-map');
        map.style.height = 12 +'in';
        w.mapListeners.triggerMapResize();
      }
      setTimeout(()=>{
        w.print();
        this.saveUserMap();
      }, 1000);
    }, 0);
    this.segmentService.log(SegmentEvents.printButtonClicked, {
      map_id: this.mapService.currentUserMap && this.mapService.currentUserMap.id ? this.mapService.currentUserMap.id : null,
      paper_size : this.selectedPrintOption.eventName
    });
  }

  saveUserMap() {
    let w = (<any>window),
    newUserMap = {
      name: '',
      notes: '',
      mapData: []
    };
    newUserMap.name = 'Printed Map ' + this.getCurrentDateTime();
    w.Events.publish('saveCurrentUserMap', {data: newUserMap});
  }

  toggleNextButton(value) {
    this.showPrintPreviewStep2 = value;
    if(value) {
      this.addPrintPreviewStep2Setting();
    } else {
      this.selectedPrintOption = null;
      this.removePrintPreviewStep2Setting();
      this.removePrintModeMapSetting();
      this.togglePerfectScrollbar(false);
    }
    (<any>window).Events.publish('detectChanges');
  }

  addPrintPreviewStep1Setting() {
    document.getElementsByTagName('body')[0].classList.add('print-preview-step-1');
  }

  removePrintPreviewStep1Setting() {
    let w = (<any>window),
        body = document.getElementsByTagName('body')[0].classList;
    body.contains('print-preview-step-1') && body.remove('print-preview-step-1');
  }

  addPrintPreviewStep2Setting() {
    document.getElementsByTagName('body')[0].classList.add('print-preview-step-2');
    this.toggleMapZoomListener(false);
    this.togglePerfectScrollbar(true);
  }

  removePrintPreviewStep2Setting() {
    let w = (<any>window),
        body = document.getElementsByTagName('body')[0].classList;
    body.contains('print-preview-step-2') && body.remove('print-preview-step-2');
    this.toggleMapZoomListener(true);
    this.togglePerfectScrollbar(false);
  }

  removePrintModeMapSetting() {
    let w = (<any>window),
        body = document.getElementsByTagName('body')[0].classList;
    body.contains('print-mode') && body.contains(w.printMode.currentPrintSettings.printName + '-print-mode') && w.printMode.exit();
  }

  appendZeroToNumber(number) {
    if(number.toString().length === 1) {
        number = '0' + number;
    }
    return number;
  }

  getCurrentDateTime() {
    let d = new Date(),
    date = this.appendZeroToNumber(d.getDate()),
    month = this.appendZeroToNumber(d.getMonth()),
    year = d.getFullYear(),
    hours = this.appendZeroToNumber(d.getHours()),
    minutes = this.appendZeroToNumber(d.getMinutes());
    return month + '/' + date + '/' + year + '_' + hours + ':' + minutes;
  }

  togglePerfectScrollbar(toggle) {
    if(toggle) {
      this.perfectScrollbar = new PerfectScrollbar('#embed-container');
    } else {
      if(this.perfectScrollbar) {
        this.perfectScrollbar.destroy();
        this.perfectScrollbar = null;
      }
    }
  }

  toggleMapZoomListener(toggle) {
    let w = (<any>window);
    w.map.setOptions({ scrollwheel: toggle });
  }

  ngOnDestroy() {
    this.removePrintPreviewStep1Setting();
    this.removePrintPreviewStep2Setting();
    this.removePrintModeMapSetting();
  }
}


// WEBPACK FOOTER //
// ./src/app/components/print/print.component.ts